export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '0e3c91b5-f874-45c8-8d4f-da5fdfdcfa06';
export const MODAL_CLOSE_SEC = 2.5;
